var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-selector j-area-dcount",on:{"click":_vm.handleAreaConfirmPopup}},[_vm._v("\n  "+_vm._s(_vm.curLocation || _vm.letter.areaLimitSwitchRegion)+"\n  "),_c('Icon',{staticClass:"area-icon",attrs:{"name":"down"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }